import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, KeyValuePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { TransportMapStore } from '@/new-transport/transport-map/_store/transport-map.store';
import { AdvancedStopKind, StopKind } from '@/new-transport/_models/transport.model';
import { LegendComponent } from '@/new-transport/transport-map/transport-map-timeline/legend/legend.component';

@Component({
	selector: 'app-transport-map-timeline',
	standalone: true,
	imports: [AsyncPipe, NgForOf, NgIf, KeyValuePipe, NgClass, LegendComponent],
	templateUrl: './transport-map-timeline.component.html',
	styleUrl: './transport-map-timeline.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportMapTimelineComponent {
	vehicles = inject(TransportMapStore).timeline;
	readonly StopKind = StopKind;
	readonly AdvancedStopKind = AdvancedStopKind;
}
